import React from 'react';
import { Box, HStack, Link, Icon, Text } from '@chakra-ui/react'; // Import Text
import { FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => (
  <Box bg="pastelWhite" py={4} textAlign="center">
    <HStack justify="center" spacing={4} mb={2}>
      <Link href="https://www.facebook.com/groups/228349298612542" isExternal>
        <Icon as={FaFacebook} boxSize={6} color="pastelBlue" />
      </Link>
      <Link href="https://www.instagram.com/suzan_cook/" isExternal>
        <Icon as={FaInstagram} boxSize={6} color="pastelGreen" />
      </Link>
    </HStack>
    <Text fontSize="sm" color="gray.600">
      © 2024 Suzan Cook. All Rights Reserved. Designed by JLC Digital. 
    </Text>
  </Box>
);

export default Footer;
